package com.rosario.juridico.ui.screens

import com.rosario.juridico.ui.CommonBackHandler
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.*
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.*
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.GridItemSpan
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import com.rosario.juridico.ui.components.WebLazyGridScrollbar
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.Logout
import androidx.compose.material.icons.automirrored.filled.Login
import androidx.compose.material.icons.automirrored.filled.TrendingUp
import androidx.compose.material.icons.automirrored.filled.Assignment
import androidx.compose.material.icons.automirrored.filled.FactCheck
import androidx.compose.material.icons.automirrored.filled.ReceiptLong
import androidx.compose.material.icons.automirrored.filled.Chat
import androidx.compose.material.icons.automirrored.filled.EventNote
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.input.nestedscroll.NestedScrollConnection
import androidx.compose.ui.input.nestedscroll.NestedScrollSource
import androidx.compose.ui.input.nestedscroll.nestedScroll
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import androidx.navigation.NavController
import com.rosario.juridico.currentDateString
import com.rosario.juridico.navigation.Routes
import com.rosario.juridico.openWhatsApp
import com.rosario.juridico.openEmail
import com.rosario.juridico.platform.FirebaseProxy
import com.rosario.juridico.platform.UserStatus
import com.rosario.juridico.platform.PromoResult
import com.rosario.juridico.domain.*
import com.rosario.juridico.premium.PremiumManager
import com.rosario.juridico.premium.DebugPremiumOverlay
import com.rosario.juridico.marketplace.billing.getBillingProvider
import com.rosario.juridico.marketplace.viewmodel.MarketplaceViewModel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlin.math.roundToInt
import androidx.compose.foundation.text.selection.LocalTextSelectionColors
import androidx.compose.foundation.text.selection.TextSelectionColors
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.ui.graphics.SolidColor
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.lifecycle.viewmodel.compose.viewModel
import kotlinx.coroutines.flow.*
import juridico5.composeapp.generated.resources.Res
import kotlinx.coroutines.Dispatchers
import com.rosario.juridico.platform.BackendClient
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll


object Constantes {
    const val VALOR_JUS_DOUBLE     = AppMontos.JUS_DOUBLE
    const val VALOR_JUS_STR        = AppMontos.JUS_STR
    const val VALOR_JUS_FORMATEADO = AppMontos.JUS_FORMATEADO
}

enum class SeccionDashboard(val titulo: String) {
    HONORARIOS("Calculadora legal"),
    AGENDA("Agenda expedientes"),
    PLAZOS("Calendario\nlegal"),
    MODELOS("Modelos\nescritos")
}

data class ItemBusqueda(
    val titulo: String,
    val subtitulo: String,
    val ruta: String,
    val icono: ImageVector,
    val tags: String = "",
    val fuente: String = "APP"
)

/**
 * PASO 1: Abstracción (SearchableItem)
 * Estructura intermedia para el Motor de Búsqueda Global.
 */
data class SearchableItem(
    val titulo: String,
    val descripcionBusqueda: String,
    val ruta: String,
    val fuente: String,
    val searchKey: String = ""
)

/**
 * PASO 2: Repositorio de Búsqueda Global.
 * Ahora centralizado y consumiendo el DependenciaRepository (JSON).
 */
class GlobalSearchRepository {
    private val otherFilesToIndex = listOf(
        "files/sellados_base.txt",
        "files/honorarios_profesionales_abogados.txt",
        "files/cuanto_cuesta_un_tramite.txt"
    )

    suspend fun getUnifiedItems(): List<ItemBusqueda> {
        val searchableItems = mutableListOf<SearchableItem>()

        // A) Integración de Calculadoras (Hardcoded)
        itemsBusqueda.forEach {
            searchableItems.add(
                SearchableItem(
                    titulo = it.titulo,
                    descripcionBusqueda = it.subtitulo,
                    ruta = it.ruta,
                    fuente = "APP",
                    searchKey = "${it.titulo} ${it.subtitulo} ${it.tags}".unaccent().lowercase()
                )
            )
        }

        // B) Integración de Dependencias Públicas (Desde el nuevo Repositorio JSON)
        val dependencias = DependenciaRepository.getDependencias()
        dependencias.forEach { dep ->
            searchableItems.add(
                SearchableItem(
                    titulo = dep.nombre,
                    descripcionBusqueda = if (dep.descripcion.isNotBlank()) dep.descripcion else dep.direccion,
                    ruta = Routes.guiaInfo(dep.id), // Deep link con ID
                    fuente = "GUIA",
                    searchKey = dep.search_key // Usamos directamente el campo del JSON
                )
            )
        }

        // C) Otros archivos .txt (Sellados, etc.) - Mantener por ahora
        for (filePath in otherFilesToIndex) {
            try {
                val bytes = Res.readBytes(filePath)
                val content = bytes.decodeToString()

                val pipeItems = content.lines()
                    .filter { it.isNotBlank() && !it.startsWith("#") && it.contains("|") }
                    .mapNotNull { line ->
                        val parts = line.split("|")
                        if (parts.size >= 2) {
                            SearchableItem(
                                titulo = parts[1].trim(),
                                descripcionBusqueda = parts.getOrNull(2)?.trim() ?: "",
                                ruta = when {
                                    filePath.contains("sellados") -> Routes.CODIGOS_SELLADOS
                                    else -> Routes.GUIA_INFO
                                },
                                fuente = "ARCHIVO",
                                searchKey = line.replace("|", " ").unaccent().lowercase()
                            )
                        } else null
                    }
                searchableItems.addAll(pipeItems)
            } catch (e: Exception) {
                println("Error indexando $filePath: ${e.message}")
            }
        }

        return searchableItems.distinctBy { it.titulo + it.descripcionBusqueda.take(20) }
            .map { item ->
                ItemBusqueda(
                    titulo = item.titulo,
                    subtitulo = if (item.descripcionBusqueda.length > 60) 
                                item.descripcionBusqueda.take(57) + "..." 
                                else item.descripcionBusqueda,
                    ruta = item.ruta,
                    icono = when (item.fuente) {
                        "APP" -> Icons.Default.Calculate
                        "ARCHIVO" -> Icons.AutoMirrored.Filled.ReceiptLong
                        else -> Icons.Default.LocationOn
                    },
                    tags = item.searchKey, // tags ahora contiene la clave de búsqueda pre-normalizada
                    fuente = item.fuente
                )
            }
    }
}

/**
 * PASO 3: Adaptación del ViewModel y Lógica de Filtrado.
 * Gestiona el StateFlow unificado para la búsqueda global.
 */
class GlobalSearchViewModel : ViewModel() {
    private val repository = GlobalSearchRepository()
    private val _searchQuery = MutableStateFlow("")
    val searchQuery = _searchQuery.asStateFlow()

    private val _allItems = MutableStateFlow<List<ItemBusqueda>>(emptyList())

    val filteredResults = _searchQuery
        .debounce(300)
        .combine(_allItems) { query, items ->
            if (query.isBlank()) emptyList()
            else {
                val normalizedQuery = query.unaccent().lowercase()
                val searchTerms = normalizedQuery.split(" ").filter { it.isNotBlank() }
                
                items.filter { item ->
                    // Búsqueda ultrarrápida usando tags (que ya contiene el searchKey pre-normalizado)
                    searchTerms.all { term -> item.tags.contains(term) }
                }
            }
        }
        .flowOn(Dispatchers.Default) // Ejecutar filtrado fuera del main thread
        .stateIn(viewModelScope, SharingStarted.WhileSubscribed(5000), emptyList())

    init {
        viewModelScope.launch {
            _allItems.value = repository.getUnifiedItems()
        }
    }

    fun onQueryChange(query: String) {
        _searchQuery.value = query
    }
}

fun String.unaccent(): String {
    val accents = "áéíóúüñÁÉÍÓÚÜÑ"
    val noAccents = "aeiouunAEIOUUN"
    return this.map { char ->
        val index = accents.indexOf(char)
        if (index >= 0) noAccents[index] else char
    }.joinToString("")
}

val itemsBusqueda = listOf(
    // --- HONORARIOS Y APORTES ---
    ItemBusqueda("Honorarios Profesionales", "Leyes 13151 y 6767", Routes.CALCULADORA_HONORARIOS, Icons.Default.Calculate, "abogados aportes caja matricula ley aranceles regulacion unidad medida jus uvm tributario"),
    ItemBusqueda("Calculadora de Mediación", "Prejudicial, gastos y aportes", Routes.CALCULADORA_HONORARIOS, Icons.Default.Handshake, "mediador agem boletas honorarios gastos prejudicial boleta mediacion prejudicial obligatoria"),
    ItemBusqueda("Caja de Seguridad Social", "Aportes y Jubilación", Routes.CALCULADORA_HONORARIOS, Icons.Default.AccountBalance, "jubilacion aportes ley 6767 caja abogados forense previsional"),

    // --- CÁLCULOS ECONÓMICOS ---
    ItemBusqueda("Intereses Judiciales", "Tasas BNA activa y pasiva", Routes.CALCULADORA_ECONOMICA, Icons.Default.CurrencyExchange, "economica judicial tasa interes capitalizacion anatocismo tasa pasiva suma intereses"),
    ItemBusqueda("Inflación IPC", "Actualización por índice de precios", Routes.CALCULADORA_ECONOMICA, Icons.Default.Timeline, "ipc precios ajuste costo vida inflacion indec depreciacion monetaria perdida valor adquisitivo"),
    ItemBusqueda("Ajuste Salarial", "Índice de salarios y convenios", Routes.CALCULADORA_ECONOMICA, Icons.AutoMirrored.Filled.TrendingUp, "sueldo remuneracion ajuste remunerativo salarios paritarias ripte sueldos"),
    ItemBusqueda("Calculadora CAC", "Índice Cámara de Construcción", Routes.CALCULADORA_ECONOMICA, Icons.Default.Construction, "obra edificacion construccion cac materiales edificios costos"),
    ItemBusqueda("SMVM y Alimentos", "Salario Mínimo Vital y Móvil", Routes.CALCULADORA_ECONOMICA, Icons.Default.FamilyRestroom, "cuota alimentaria menores alimentos smvm manutencion salario minimo vital movil"),

    // --- TIEMPOS Y PLAZOS ---
    ItemBusqueda("Contador de Días", "Plazos hábiles y corridos", Routes.CALCULADORA_DIAS, Icons.Default.CalendarMonth, "fechas tiempo calendario dias procesales feriados suspensivos termino computo"),
    ItemBusqueda("Caducidad de Instancia", "Cálculo CPCC Santa Fe", Routes.CALCULADORA_VENCIMIENTOS, Icons.Default.Alarm, "plazos perencion caducidad vencimiento inactividad procesal 6 meses civil"),

    // --- DAÑOS E INCAPACIDAD ---
    ItemBusqueda("Incapacidad Física", "Fórmula Méndez y Vuotto", Routes.CALCULADORA_INCAPACIDAD, Icons.Default.HealthAndSafety, "art civil incapacidad puntos baremo baremos mendez vuotto cuantificacion daños accidente transito laboral"),

    // --- SELLADOS Y TASAS ---
    ItemBusqueda("Códigos de Sellados", "Tasas Poder Judicial Santa Fe", Routes.CODIGOS_SELLADOS, Icons.Default.AccountBalance, "boletas sellado judicial pjsf justicia pjs pjsf reposicion fojas tasa de justicia"),
    ItemBusqueda("Sellado de Locación", "Alquileres y API", Routes.CODIGOS_SELLADOS, Icons.Default.Key, "alquiler locacion sellado contrato vivienda comercio api impuesto sellos"),

    // --- DOCUMENTOS E IA ---
    ItemBusqueda("Modelos de Escritos", "Base de documentos y contratos", Routes.DOCUMENTOS, Icons.Default.Folder, "word pdf modelos demanda contestacion escritos oficio telegrama carta documento demanda sucesion divorcio alquiler locacion desalojo familia"),
    ItemBusqueda("Generador de Contratos IA", "Locación e Inteligencia Artificial", Routes.GENERADOR_CONTRATO, Icons.Default.Description, "alquiler locacion ia contrato inteligente inmueble vivienda comercial redactar"),
    ItemBusqueda("Consulta IA Legal", "Asistente inteligente para abogados", Routes.CONSULTA, Icons.Default.SmartToy, "robot abogado inteligencia artificial consulta gpt legal chat asesoramiento"),

    // --- AGENDA Y GESTIÓN ---
    ItemBusqueda("Agenda de Expedientes", "Seguimiento de causas y plazos", Routes.AGENDA_EXPEDIENTES, Icons.AutoMirrored.Filled.Assignment, "mis casos tramites expediente judicial carpetas juicios seguimiento juzgado"),
    ItemBusqueda("Agenda PROMESA", "Asistente mediación salud", Routes.AGENDA_PROMESA, Icons.AutoMirrored.Filled.FactCheck, "salud decreto 379/2025 procedimiento pasos discapacidad amparo medicina"),
    ItemBusqueda("Nuevo Expediente", "Alta de carpeta en la agenda", Routes.NUEVO_EXPEDIENTE, Icons.Default.Add, "alta nuevo caso agenda expediente judicial crear registro"),

    // --- MARKETPLACE ---
    ItemBusqueda("Marketplace Legal", "Publicar o responder consultas", Routes.LISTADO_CONSULTAS, Icons.Default.Campaign, "clientes trabajo consultas publicar abogado bolsa laboral"),
    ItemBusqueda("Directorio Abogados Verificados", "Buscar profesionales por especialidad y localidad", Routes.DIRECTORIO_AVVO, Icons.Default.VerifiedUser, "abogados directorio avvo verificados especialidad provincia rosario santa fe matricula"),

    // --- TEMÁTICAS ESPECÍFICAS (SINÓNIMOS AMPLIOS) ---
    ItemBusqueda("Sucesiones", "Modelos y Honorarios", Routes.DOCUMENTOS, Icons.Default.FolderShared, "herencia sucesion herederos declaratoria bienes testamento legatarios"),
    ItemBusqueda("Divorcio express", "Familia y Convenios", Routes.DOCUMENTOS, Icons.Default.HeartBroken, "separacion divorcio unilateral express convenio regulador familia alimentos"),
    ItemBusqueda("Desalojo de Inmueble", "Modelos de demanda", Routes.DOCUMENTOS, Icons.Default.HomeWork, "locacion alquiler falta de pago vencimiento contrato desalojar ocupantes"),
    ItemBusqueda("Accidentes de Tránsito", "Cálculo de Daños", Routes.CALCULADORA_INCAPACIDAD, Icons.Default.DirectionsCar, "choque siniestro vial seguro indemnizacion mendez vuotto civil transito"),
    ItemBusqueda("Amparo de Salud", "Agenda PROMESA", Routes.AGENDA_PROMESA, Icons.Default.MedicalServices, "obra social prepaga amparo salud medicacion tratamiento discapacidad")
)

@Composable
fun PantallaInicio(
    navController: NavController,
    viewModel: MarketplaceViewModel,
    onShowExitDialog: () -> Unit = {},
    onOpenDrawer: () -> Unit = {}
) {
    CommonBackHandler(enabled = true) {
        onShowExitDialog()
    }

    val secciones  = SeccionDashboard.entries.toTypedArray()
    var currentTabIndex by remember { mutableStateOf(0) }
    val scope      = rememberCoroutineScope()
    var fabExpanded by remember { mutableStateOf(false) }
    val isDark = isSystemInDarkTheme()

    // --- MARKETPLACE ---
    val searchViewModel: GlobalSearchViewModel = viewModel { GlobalSearchViewModel() }
    val searchQuery by searchViewModel.searchQuery.collectAsState()
    val filteredResults by searchViewModel.filteredResults.collectAsState()

    // Estado de Sesión
    val userEmail by AppUsageManager.instance.currentUserEmail.collectAsState()
    val isLoggedIn = userEmail != null && !FirebaseProxy.isAnonymous()
    var showLogoutDialog by remember { mutableStateOf(false) }

    val premiumManager = AppUsageManager.instance
    val userStatus by premiumManager.userStatus.collectAsState()
    val userRol = userStatus.rol

    val isAdmin = userStatus.isAdmin || userRol.equals("admin", ignoreCase = true) || PremiumManager.isAdmin

    var showTrialActivationDialog by remember { mutableStateOf(false) }
    var showPromoDialog by remember { mutableStateOf(false) }
    var isNavigatingMarketplace by remember { mutableStateOf(false) }

    var diasEspeciales by remember { mutableStateOf<List<DiaEspecial>>(emptyList()) }
    
    LaunchedEffect(Unit) {
        diasEspeciales = CalendarioParser.cargarTodo()
        viewModel.loadCurrentUserAbogado()
    }

    // Función auxiliar para navegar a pantallas que requieren login o acceso premium
    val navigateWithAuth: (String) -> Unit = { route ->
        val isLegitimateUser = FirebaseProxy.isLoggedIn() && 
                               !FirebaseProxy.isAnonymous() && 
                               !userEmail.isNullOrBlank()

        val isPremiumFeature = when(route) {
            // Homologación: Se quitan las rutas de IA del bloqueo preventivo.
            // Ahora se comportan como las calculadoras (validación in-situ).
            Routes.ASISTENTE_REDACCION -> true
            else -> false
        }

        val requiresAuth = when {
            route == Routes.AGENDA_EXPEDIENTES || route == Routes.NUEVO_EXPEDIENTE ||
            route == Routes.PUBLICAR_CONSULTA || route == Routes.LISTADO_CONSULTAS ||
            route == Routes.PERFIL_ABOGADO || route.startsWith("onboarding_rol") -> true
            else -> isPremiumFeature
        }
        
        if (requiresAuth && !isLegitimateUser) {
            com.rosario.juridico.domain.AppUsageManager.pendingRoute = route
            navController.navigate(Routes.login())
        } else if ((route == Routes.LISTADO_CONSULTAS || route.startsWith("onboarding_rol")) && isLegitimateUser) {
            scope.launch {
                isNavigatingMarketplace = true
                if (viewModel.currentUserAbogado.value == null) {
                    viewModel.loadCurrentUserAbogadoSuspend()
                }
                while (viewModel.isLoadingPerfil.value) {
                    kotlinx.coroutines.delay(100)
                }
                isNavigatingMarketplace = false

                val lawyer = viewModel.currentUserAbogado.value
                val hasCompleteProfile = lawyer != null && 
                                        !lawyer.matricula.isNullOrBlank() && 
                                        !lawyer.telefono.isNullOrBlank()

                if (hasCompleteProfile) {
                    navController.navigate(Routes.LISTADO_CONSULTAS)
                } else {
                    navController.navigate("onboarding_rol?role=abogado")
                }
            }
        } else if (isPremiumFeature) {
            if (!isLegitimateUser) {
                com.rosario.juridico.domain.AppUsageManager.pendingRoute = route
                navController.navigate(Routes.login())
            } else {
                val access = AppUsageManager.instance.checkAccess()
                if (access == AccessState.PREMIUM_ACTIVE) {
                    navController.navigate(route)
                } else {
                    navController.navigate(Routes.PAYWALL)
                }
            }
        } else {
            navController.navigate(route)
        }
    }

    @Composable
    fun MainDashboardUI() {
        Scaffold(
            modifier       = Modifier.fillMaxSize(),
            containerColor = MaterialTheme.colorScheme.background,
            contentWindowInsets = WindowInsets(0, 0, 0, 0),
            floatingActionButton = {
                SpeedDialFab(
                    expanded       = fabExpanded,
                    onExpandChange = { fabExpanded = it },
                    isLoggedIn     = isLoggedIn,
                    onActionClick  = { action ->
                        when (action) {
                            "whatsapp" -> openWhatsApp("5493413850100")
                            "email"    -> openEmail("appjuridicorosario@gmail.com")
                            "logout"   -> showLogoutDialog = true
                            "login"    -> navController.navigate(Routes.login())
                        }
                        fabExpanded = false
                    }
                )
            }
        ) { paddingValues ->
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(paddingValues)
                    .pointerInput(Unit) {
                        var dragAccumulator = 0f
                        val swipeThreshold = 350f

                        detectHorizontalDragGestures(
                            onDragEnd = { dragAccumulator = 0f },
                            onDragCancel = { dragAccumulator = 0f }
                        ) { _, dragAmount ->
                            dragAccumulator += dragAmount
                            if (dragAccumulator > swipeThreshold) {
                                if (currentTabIndex > 0) {
                                    currentTabIndex -= 1
                                }
                                dragAccumulator = 0f
                            } else if (dragAccumulator < -swipeThreshold) {
                                if (currentTabIndex < secciones.size - 1) {
                                    currentTabIndex += 1
                                }
                                dragAccumulator = 0f
                            }
                        }
                    }
            ) {
                val gridState = rememberLazyGridState()

                WebLazyGridScrollbar(state = gridState, modifier = Modifier.fillMaxSize()) {
                    LazyVerticalGrid(
                        state    = gridState,
                        columns  = GridCells.Fixed(2),
                        modifier = Modifier.fillMaxSize(),
                        contentPadding = PaddingValues(
                            top    = 16.dp,
                            bottom = 80.dp,
                            start  = 16.dp,
                            end    = 16.dp
                        ),
                        verticalArrangement   = Arrangement.spacedBy(16.dp),
                        horizontalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        // CABECERA GLOBAL
                        item(span = { GridItemSpan(2) }) {
                            Column(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .padding(bottom = 8.dp),
                                verticalArrangement = Arrangement.spacedBy(20.dp)
                            ) {
                                HeaderDashboard(
                                    userStatus = userStatus,
                                    searchQuery = searchQuery,
                                    onSearchQueryChange = { searchViewModel.onQueryChange(it) },
                                    onPaywallClick = {
                                        if (!isLoggedIn) {
                                            navController.navigate(Routes.login())
                                        } else {
                                            navController.navigate(Routes.PAYWALL)
                                        }
                                    },
                                    onMenuClick = onOpenDrawer,
                                    onPromoClick = {
                                        if (!isLoggedIn || FirebaseProxy.isAnonymous()) {
                                            navController.navigate(Routes.login())
                                        } else {
                                            showPromoDialog = true
                                        }
                                    },
                                    onConsultAIClick = { query ->
                                        com.rosario.juridico.domain.AppUsageManager.pendingAiQuery = query
                                        navigateWithAuth(Routes.consulta(query))
                                    },
                                    isSearchNoResults = searchQuery.isNotBlank() && filteredResults.isEmpty()
                                )
                                SegmentedControl(
                                    secciones = secciones,
                                    seleccionada = secciones[currentTabIndex],
                                    onSeleccion = { seccion: SeccionDashboard ->
                                        currentTabIndex = seccion.ordinal
                                    }
                                )
                            }
                        }

                        when (secciones[currentTabIndex]) {
                                SeccionDashboard.HONORARIOS -> {
                                    item(span = { GridItemSpan(2) }) {
                                        Column {
                                            if (userStatus.consistency == com.rosario.juridico.premium.EntitlementConsistencyState.STALE_CACHE && userStatus.gracePeriod) {
                                                GracePeriodBanner()
                                                Spacer(Modifier.height(16.dp))
                                            }



                                            ValoresReferenciaCard()
                                            Spacer(Modifier.height(24.dp))
                                        }
                                    }
                                    item(span = { GridItemSpan(2) }) {
                                        CardHonorariosDestacada(onClick = { navigateWithAuth(Routes.CALCULADORA_HONORARIOS) })
                                    }
                                    item(span = { GridItemSpan(2) }) { SeccionTituloDashboard("Calculadoras") }
                                    item { DashboardGridItem("Índices/Tasas/Intereses", "Económica", Icons.Default.Calculate) { navigateWithAuth(Routes.CALCULADORA_ECONOMICA) } }
                                    item { DashboardGridItem("Días", "Háb./Corr.", Icons.Default.CalendarMonth) { navigateWithAuth(Routes.CALCULADORA_DIAS) } }
                                    item { DashboardGridItem("Caducidad", "Vencimientos CPCC", Icons.Default.Alarm) { navigateWithAuth(Routes.CALCULADORA_VENCIMIENTOS) } }
                                    item { DashboardGridItem("Incapacidad", "Fórmula Méndez y Vuotto", Icons.Default.HealthAndSafety) { navigateWithAuth(Routes.CALCULADORA_INCAPACIDAD) } }
                                    item { DashboardGridItem("Sellados API/Tasa de Justicia Santa Fe", "Poder Jud.", Icons.Default.AccountBalance) { navigateWithAuth(Routes.CODIGOS_SELLADOS) } }
                                    item { DashboardGridItem("Guía Juzgados/Sala Mediación/Dependencias", "Direcciones", Icons.Default.LocationOn) { navigateWithAuth(Routes.GUIA_INFO) } }
                                    item(span = { GridItemSpan(2) }) { SeccionTituloDashboard("Marketplace Legal") }
                                    
                                    item(span = { GridItemSpan(2) }) {
                                        Card(
                                            onClick = { navigateWithAuth(Routes.PUBLICAR_CONSULTA) },
                                            modifier = Modifier.fillMaxWidth().padding(horizontal = 4.dp, vertical = 6.dp),
                                            colors = CardDefaults.cardColors(
                                                containerColor = MaterialTheme.colorScheme.primaryContainer,
                                                contentColor = MaterialTheme.colorScheme.onPrimaryContainer
                                            ),
                                            shape = RoundedCornerShape(16.dp),
                                            elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
                                        ) {
                                            Row(
                                                modifier = Modifier.padding(16.dp).fillMaxWidth(),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                Icon(Icons.Default.PersonSearch, contentDescription = null, modifier = Modifier.size(36.dp))
                                                Spacer(Modifier.width(16.dp))
                                                Column {
                                                    Text("Portal Clientes", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
                                                    Text("Necesito un Abogado - Publicar consultas y recibir presupuestos", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onPrimaryContainer.copy(alpha = 0.8f))
                                                }
                                            }
                                        }
                                    }
                                    
                                    item(span = { GridItemSpan(2) }) {
                                        Card(
                                            onClick = { navigateWithAuth(Routes.LISTADO_CONSULTAS) },
                                            enabled = !isNavigatingMarketplace,
                                            modifier = Modifier.fillMaxWidth().padding(horizontal = 4.dp, vertical = 6.dp),
                                            colors = CardDefaults.cardColors(
                                                containerColor = MaterialTheme.colorScheme.secondaryContainer,
                                                contentColor = MaterialTheme.colorScheme.onSecondaryContainer
                                            ),
                                            shape = RoundedCornerShape(16.dp),
                                            elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
                                        ) {
                                            Row(
                                                modifier = Modifier.padding(16.dp).fillMaxWidth(),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                if (isNavigatingMarketplace) {
                                                    CircularProgressIndicator(
                                                        modifier = Modifier.size(36.dp),
                                                        color = MaterialTheme.colorScheme.onSecondaryContainer,
                                                        strokeWidth = 3.dp
                                                    )
                                                } else {
                                                    Icon(Icons.Default.Work, contentDescription = null, modifier = Modifier.size(36.dp))
                                                }
                                                Spacer(Modifier.width(16.dp))
                                                Column {
                                                    Text(
                                                        text = if (isNavigatingMarketplace) "Verificando Perfil..." else "Portal Abogados",
                                                        fontWeight = FontWeight.Bold,
                                                        style = MaterialTheme.typography.titleMedium
                                                    )
                                                    Text("Soy Profesional - Captar clientes y enviar honorarios", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSecondaryContainer.copy(alpha = 0.8f))
                                                }
                                            }
                                        }
                                    }

                                    item(span = { GridItemSpan(2) }) {
                                        Card(
                                            onClick = { navigateWithAuth(Routes.DIRECTORIO_AVVO) },
                                            modifier = Modifier.fillMaxWidth().padding(horizontal = 4.dp, vertical = 6.dp),
                                            colors = CardDefaults.cardColors(
                                                containerColor = MaterialTheme.colorScheme.tertiaryContainer,
                                                contentColor = MaterialTheme.colorScheme.onTertiaryContainer
                                            ),
                                            shape = RoundedCornerShape(16.dp),
                                            elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
                                        ) {
                                            Row(
                                                modifier = Modifier.padding(16.dp).fillMaxWidth(),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                Icon(Icons.Default.VerifiedUser, contentDescription = null, modifier = Modifier.size(36.dp))
                                                Spacer(Modifier.width(16.dp))
                                                Column {
                                                    Text("Directorio Abogados Verificados", fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleMedium)
                                                    Text("Buscar profesionales por especialidad y localidad", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onTertiaryContainer.copy(alpha = 0.8f))
                                                }
                                            }
                                        }
                                    }

                                    if (isAdmin) {
                                        item(span = { GridItemSpan(2) }) { SeccionTituloDashboard("Administración") }
                                        item(span = { GridItemSpan(2) }) {
                                            MenuItemDashboard(
                                                titulo = "Panel de Control",
                                                subtitulo = "Aprobar y moderar consultas",
                                                icono = Icons.Default.AdminPanelSettings,
                                                onClick = { navController.navigate(Routes.PANEL_ADMIN) }
                                            )
                                        }
                                    }
                                }
                                SeccionDashboard.AGENDA -> {
                                    // Componente unificado: Encabezado interactivo de Agenda
                                    item(span = { GridItemSpan(2) }) {
                                        Card(
                                            onClick = { navigateWithAuth(Routes.AGENDA_EXPEDIENTES) },
                                            modifier = Modifier
                                                .fillMaxWidth()
                                                .padding(horizontal = 4.dp, vertical = 8.dp),
                                            colors = CardDefaults.cardColors(
                                                containerColor = MaterialTheme.colorScheme.primaryContainer,
                                                contentColor = MaterialTheme.colorScheme.onPrimaryContainer
                                            ),
                                            shape = RoundedCornerShape(16.dp),
                                            elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
                                        ) {
                                            Row(
                                                modifier = Modifier.padding(16.dp),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                Icon(
                                                    imageVector = Icons.Default.CalendarMonth,
                                                    contentDescription = null,
                                                    tint = MaterialTheme.colorScheme.primary,
                                                    modifier = Modifier.size(32.dp)
                                                )
                                                Spacer(Modifier.width(12.dp))
                                                Column(modifier = Modifier.weight(1f)) {
                                                    Text(
                                                        text = "Agenda Judicial",
                                                        style = MaterialTheme.typography.titleMedium,
                                                        fontWeight = FontWeight.Bold
                                                    )
                                                    Text(
                                                        text = "Gestiona tus expedientes, plazos y vencimientos",
                                                        style = MaterialTheme.typography.bodyMedium,
                                                        color = MaterialTheme.colorScheme.onPrimaryContainer.copy(alpha = 0.8f)
                                                    )
                                                }
                                            }
                                        }
                                    }
                                    item { DashboardGridItem("Nuevo Caso", "Alta rápida", Icons.Default.Add) { navigateWithAuth(Routes.NUEVO_EXPEDIENTE) } }
                                    item { DashboardGridItem("Agenda PROMESA", "Mediación Salud", Icons.AutoMirrored.Filled.FactCheck) { navigateWithAuth(Routes.AGENDA_PROMESA) } }
                                    item { DashboardGridItem("Vencimientos", "Próximos 7 días", Icons.AutoMirrored.Filled.EventNote) { navigateWithAuth(Routes.AGENDA_EXPEDIENTES) } }
                                }
                                SeccionDashboard.PLAZOS -> {
                                    item(span = { GridItemSpan(2) }) { SeccionTituloDashboard("Gestión de Tiempos") }
                                    item(span = { GridItemSpan(2) }) { CalendarioPlaceholder(navController, { navigateWithAuth(it) }) }
                                    item(span = { GridItemSpan(2) }) {
                                        CalendarioJudicialComponent(diasEspeciales = diasEspeciales)
                                    }
                                }
                                SeccionDashboard.MODELOS -> {
                                    item(span = { GridItemSpan(2) }) { SeccionTituloDashboard("Herramientas IA") }
                                    item(span = { GridItemSpan(2) }) {
                                        MenuItemDashboard("Generador de Contratos", "IA Premium", Icons.Default.Description, { navigateWithAuth(Routes.GENERADOR_CONTRATO) }, "Premium")
                                    }
                                    item { DashboardGridItem("Escritos", "Modelos", Icons.Default.Folder) { navigateWithAuth(Routes.DOCUMENTOS) } }
                                    item { DashboardGridItem("Consulta IA", "Legal", Icons.Default.SmartToy) { navigateWithAuth(Routes.CONSULTA) } }
                                }
                            }

                            item(span = { GridItemSpan(2) }) {
                                PagerIndicator(count = secciones.size, selectedIndex = currentTabIndex)
                            }
                            item(span = { GridItemSpan(2) }) {
                                Column(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .padding(top = 24.dp, bottom = 16.dp),
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    Text(
                                        text = "© 2026 Jurídico Rosario®",
                                        style = MaterialTheme.typography.bodyMedium,
                                        textAlign = TextAlign.Center,
                                        color = if (isDark) Color(0xFFBDBDBD) else Color(0xFF616161)
                                    )

                                    Spacer(modifier = Modifier.height(4.dp))

                                    Text(
                                        text = "Powered by Commit Analytic",
                                        style = MaterialTheme.typography.bodySmall,
                                        textAlign = TextAlign.Center,
                                        color = if (isDark) Color.LightGray else Color.Gray
                                    )
                                }
                            }
                    }
                }

                // Capa de fondo para cerrar la búsqueda al hacer clic fuera
                if (searchQuery.isNotEmpty() && filteredResults.isNotEmpty()) {
                    Box(
                        modifier = Modifier
                            .fillMaxSize()
                            .zIndex(99f)
                            .pointerInput(Unit) {
                                detectTapGestures {
                                    searchViewModel.onQueryChange("")
                                }
                            }
                    )
                }

                // Lista de resultados de búsqueda (Capa superpuesta flotante)
                AnimatedVisibility(
                    visible = searchQuery.isNotEmpty() && filteredResults.isNotEmpty(),
                    enter = fadeIn() + slideInVertically(),
                    exit = fadeOut() + slideOutVertically(),
                    modifier = Modifier
                        .zIndex(100f)
                        .padding(top = 220.dp)
                ) {
                    SearchResultsList(
                        results = filteredResults,
                        onResultClick = { item ->
                            searchViewModel.onQueryChange("")
                            navigateWithAuth(item.ruta)
                        }
                    )
                }
            }
        }
    }

    MainDashboardUI()

    if (showPromoDialog) {
        PromoCodeDialog(
            onDismissRequest = { showPromoDialog = false },
            onSuccess = {
                scope.launch {
                    val uid = FirebaseProxy.getCurrentUserId()
                    if (uid != null) {
                        PremiumManager.loadUserProfile(uid, forceRefresh = true)
                    }
                }
            }
        )
    }

    if (showLogoutDialog) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.Black.copy(alpha = 0.5f))
                .zIndex(100f)
                .pointerInput(Unit) { detectTapGestures {} },
            contentAlignment = Alignment.Center
        ) {
            Surface(
                modifier = Modifier
                    .fillMaxWidth(0.9f)
                    .widthIn(max = 400.dp)
                    .padding(16.dp),
                shape = RoundedCornerShape(24.dp),
                color = MaterialTheme.colorScheme.surface,
                tonalElevation = 6.dp,
                shadowElevation = 8.dp
            ) {
                Column(
                    modifier = Modifier.padding(24.dp),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    Text(
                        text = "Cerrar Sesión",
                        style = MaterialTheme.typography.titleLarge,
                        fontWeight = FontWeight.Bold,
                        color = MaterialTheme.colorScheme.onSurface
                    )
                    Text(
                        text = "¿Estás seguro de que deseas cerrar tu sesión actual?",
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        textAlign = TextAlign.Center
                    )
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.End,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        TextButton(onClick = { showLogoutDialog = false }) {
                            Text("Cancelar")
                        }
                        Spacer(modifier = Modifier.width(8.dp))
                        Button(
                            onClick = {
                                scope.launch {
                                    FirebaseProxy.logout()
                                    PremiumManager.clearSession()
                                    showLogoutDialog = false
                                }
                            },
                            colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error)
                        ) {
                            Text("Cerrar Sesión")
                        }
                    }
                }
            }
        }
    }



}

@Composable
fun SearchBarSimple(
    query: String,
    onQueryChange: (String) -> Unit,
    onFocusChange: (Boolean) -> Unit,
    focusRequester: FocusRequester,
    placeholder: String,
    modifier: Modifier = Modifier,
    onSearchAction: () -> Unit = {}
) {
    var isFocused by remember { mutableStateOf(false) }
    // Local state to avoid input lag on web, synced with ViewModel query
    var localText by remember(query) { mutableStateOf(query) }

    CompositionLocalProvider(
        LocalTextSelectionColors provides TextSelectionColors(
            handleColor = Color.White,
            backgroundColor = Color.White.copy(alpha = 0.4f)
        )
    ) {
        BasicTextField(
            value = localText,
            onValueChange = {
                localText = it
                onQueryChange(it)
            },
            modifier = modifier
                .fillMaxWidth()
                .height(46.dp)
                .focusRequester(focusRequester)
                .onFocusChanged { 
                    isFocused = it.isFocused
                    onFocusChange(it.isFocused)
                },
            textStyle = TextStyle(
                color = Color.White,
                fontSize = 16.sp,
                fontWeight = FontWeight.Normal
            ),
            cursorBrush = SolidColor(Color.White),
            singleLine = true,
            keyboardOptions = KeyboardOptions(imeAction = ImeAction.Search),
            keyboardActions = KeyboardActions(onSearch = { onSearchAction() }),
            decorationBox = { innerTextField ->
                Row(
                    modifier = Modifier
                        .fillMaxSize()
                        .clip(RoundedCornerShape(32.dp))
                        .background(Color.White.copy(alpha = 0.15f))
                        .border(
                            width = if (isFocused) 2.dp else 1.dp,
                            color = if (isFocused) Color(0xFFFFD700) else Color.White.copy(alpha = 0.6f),
                            shape = RoundedCornerShape(32.dp)
                        )
                        .padding(horizontal = 16.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        imageVector = Icons.Default.Search,
                        contentDescription = null,
                        tint = if (isFocused) Color(0xFFFFD700) else Color.White,
                        modifier = Modifier.size(20.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    Box(modifier = Modifier.weight(1f)) {
                        if (query.isEmpty()) {
                            Text(
                                placeholder,
                                color = Color.White.copy(alpha = 0.6f),
                                fontSize = 16.sp
                            )
                        }
                        innerTextField()
                    }
                    if (query.isNotEmpty()) {
                        IconButton(
                            onClick = { onQueryChange("") },
                            modifier = Modifier.size(36.dp)
                        ) {
                            Icon(
                                Icons.Default.Close,
                                contentDescription = null,
                                tint = Color.White,
                                modifier = Modifier.size(18.dp)
                            )
                        }
                    }
                }
            }
        )
    }
}

@Composable
fun SearchResultsList(
    results: List<ItemBusqueda>,
    onResultClick: (ItemBusqueda) -> Unit,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .shadow(8.dp, RoundedCornerShape(16.dp)),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface),
        shape = RoundedCornerShape(16.dp)
    ) {
        LazyColumn(
            modifier = Modifier.fillMaxWidth().heightIn(max = 400.dp),
            contentPadding = PaddingValues(vertical = 8.dp)
        ) {
            items(
                items = results,
                key = { it.ruta + it.titulo }
            ) { item ->
                ListItem(
                    headlineContent = { Text(item.titulo, fontWeight = FontWeight.Bold) },
                    supportingContent = { Text(item.subtitulo, style = MaterialTheme.typography.bodySmall) },
                    leadingContent = { 
                        Icon(item.icono, null, tint = MaterialTheme.colorScheme.primary) 
                    },
                    modifier = Modifier.clickable { onResultClick(item) }
                )
            }
        }
    }
}

@Composable
fun SpeedDialFab(
    expanded: Boolean, 
    onExpandChange: (Boolean) -> Unit, 
    isLoggedIn: Boolean,
    onActionClick: (String) -> Unit
) {
    Column(horizontalAlignment = Alignment.End, verticalArrangement = Arrangement.spacedBy(12.dp), modifier = Modifier.padding(end = 8.dp, bottom = 8.dp)) {
        AnimatedVisibility(
            visible = expanded, 
            enter = fadeIn() + slideInVertically(initialOffsetY = { it }), 
            exit = fadeOut() + slideOutVertically(targetOffsetY = { it })
        ) {
            Column(horizontalAlignment = Alignment.End, verticalArrangement = Arrangement.spacedBy(12.dp)) {
                if (isLoggedIn) {
                    ActionFab(Icons.AutoMirrored.Filled.Logout, "Cerrar Sesión", MaterialTheme.colorScheme.error) { onActionClick("logout") }
                } else {
                    ActionFab(Icons.AutoMirrored.Filled.Login, "Iniciar Sesión", MaterialTheme.colorScheme.primary) { onActionClick("login") }
                }
                ActionFab(Icons.Default.Email, "Email", MaterialTheme.colorScheme.primary) { onActionClick("email") }
                ActionFab(Icons.AutoMirrored.Filled.Chat, "WhatsApp", MaterialTheme.colorScheme.tertiary) { onActionClick("whatsapp") }
            }
        }
        FloatingActionButton(
            onClick = { onExpandChange(!expanded) },
            containerColor = if (expanded) MaterialTheme.colorScheme.secondaryContainer else MaterialTheme.colorScheme.tertiary,
            contentColor = if (expanded) MaterialTheme.colorScheme.onSecondaryContainer else Color.White,
            shape = CircleShape,
            elevation = FloatingActionButtonDefaults.elevation(defaultElevation = 8.dp)
        ) {
            Icon(
                imageVector = if (expanded) Icons.Default.Close else Icons.Default.Chat, 
                contentDescription = null, 
                modifier = Modifier.size(28.dp)
            )
        }
    }
}

@Composable
fun ActionFab(icon: ImageVector, label: String, color: Color, onClick: () -> Unit) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        Surface(shape = RoundedCornerShape(16.dp), color = Color.White, shadowElevation = 2.dp) {
            Text(label, modifier = Modifier.padding(horizontal = 12.dp, vertical = 6.dp), style = MaterialTheme.typography.labelMedium, color = Color.Black)
        }
        Spacer(Modifier.width(8.dp))
        SmallFloatingActionButton(onClick = onClick, containerColor = Color.White, contentColor = color, shape = CircleShape) { 
            Icon(icon, null, modifier = Modifier.size(20.dp)) 
        }
    }
}

@Composable
fun CardHonorariosDestacada(onClick: () -> Unit) {
    val isDark = isSystemInDarkTheme()
    val interactionSource = remember { MutableInteractionSource() }
    val isPressed by interactionSource.collectIsPressedAsState()

    val scale by animateFloatAsState(
        targetValue = if (isPressed) 0.97f else 1f,
        animationSpec = spring(dampingRatio = Spring.DampingRatioLowBouncy, stiffness = Spring.StiffnessLow)
    )

    Card(
        onClick   = onClick,
        modifier  = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .graphicsLayer {
                scaleX = scale
                scaleY = scale
            },
        shape     = RoundedCornerShape(16.dp),
        colors    = CardDefaults.cardColors(
            containerColor = if (isDark) MaterialTheme.colorScheme.surface else Color.White
        ),
        elevation = CardDefaults.cardElevation(
            defaultElevation = if (isDark) 0.dp else 4.dp,
            pressedElevation = if (isDark) 0.dp else 2.dp
        ),
        border    = if (isDark) {
            BorderStroke(1.dp, MaterialTheme.colorScheme.onSurface.copy(alpha = 0.05f))
        } else {
            BorderStroke(1.dp, Color(0xFFE2E8F0))
        },
        interactionSource = interactionSource
    ) {
        Row(modifier = Modifier.padding(16.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(modifier = Modifier.size(48.dp).background(MaterialTheme.colorScheme.primary, RoundedCornerShape(12.dp)), contentAlignment = Alignment.Center) { Icon(Icons.Default.Calculate, null, tint = Color.White, modifier = Modifier.size(24.dp)) }
            Spacer(modifier = Modifier.width(16.dp))
            Column(modifier = Modifier.weight(1f)) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.SpaceBetween, modifier = Modifier.fillMaxWidth()) {
                    Text("Honorarios", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                    Surface(color = if (isDark) Color(0xFF332B00) else Color(0xFFFFF9DB), shape = RoundedCornerShape(8.dp)) {
                        Text("Popular", modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp), style = MaterialTheme.typography.labelSmall, color = Color(0xFFE67E22), fontWeight = FontWeight.Bold)
                    }
                }
                Text("Leyes Prov. 13151 y 6767 Nac. 27423 y PROMESA", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.onSurfaceVariant)
            }
            Icon(
                Icons.Default.ChevronRight,
                contentDescription = null,
                tint = MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.4f),
                modifier = Modifier.size(20.dp)
            )
        }
    }
}

@Composable
fun HeaderDashboard(
    userStatus: UserStatus,
    searchQuery: String, 
    onSearchQueryChange: (String) -> Unit,
    onPaywallClick: () -> Unit,
    onMenuClick: () -> Unit,
    onPromoClick: () -> Unit,
    onConsultAIClick: (String) -> Unit = {},
    isSearchNoResults: Boolean = false
) {
    val isDark = isSystemInDarkTheme()
    val backgroundBrush = if (isDark) Brush.verticalGradient(colors = listOf(Color(0xFF0F172A), Color(0xFF040D1A))) 
                         else Brush.verticalGradient(colors = listOf(Color(0xFF0D2B4A), Color(0xFF10345A)))

    val userEmail by AppUsageManager.instance.currentUserEmail.collectAsState()
    val isLoggedIn = userEmail != null && !FirebaseProxy.isAnonymous()
    var isSearchFocused by remember { mutableStateOf(false) }
    val focusRequester = remember { FocusRequester() }
    var searchHint by remember { mutableStateOf("¿En qué puedo ayudarte?") }
    val displayName = if (isLoggedIn) userEmail!!.substringBefore("@") else "Colega"
    
    val verificationStatus by AppUsageManager.instance.verificationStatus.collectAsState()
    val scope = rememberCoroutineScope()
    var verificationSent by remember { mutableStateOf(false) }

    Column(modifier = Modifier.fillMaxWidth().statusBarsPadding()) {
        // Banner de Verificación (Solo si no está verificado y no es anónimo)
        if (verificationStatus != VerificationStatus.VERIFIED && isLoggedIn && !FirebaseProxy.isAnonymous()) {
            Surface(
                color = Color(0xFFFFF9C4), // Amarillo suave
                modifier = Modifier.fillMaxWidth()
            ) {
                Row(
                    modifier = Modifier.padding(horizontal = 16.dp, vertical = 6.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween
                ) {
                    Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.weight(1f)) {
                        Icon(Icons.Default.Error, null, tint = Color(0xFFFBC02D), modifier = Modifier.size(16.dp))
                        Spacer(Modifier.width(8.dp))
                        Text(
                            "Verificá tu correo para asegurar tu cuenta.",
                            style = MaterialTheme.typography.labelSmall,
                            color = Color.Black,
                            fontSize = 10.sp
                        )
                    }
                    TextButton(
                        onClick = {
                            if (!verificationSent) {
                                scope.launch {
                                    FirebaseProxy.sendEmailVerification()
                                    verificationSent = true
                                    delay(5000)
                                    verificationSent = false
                                }
                            }
                        },
                        contentPadding = PaddingValues(horizontal = 8.dp, vertical = 0.dp)
                    ) {
                        Text(
                            if (verificationSent) "Enviado ✓" else "Reenviar",
                            style = MaterialTheme.typography.labelSmall,
                            fontWeight = FontWeight.Bold,
                            color = Color(0xFFE65100),
                            fontSize = 10.sp
                        )
                    }
                }
            }
        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .background(
                    brush = backgroundBrush, 
                    shape = RoundedCornerShape(bottomStart = 24.dp, bottomEnd = 24.dp)
                )
                .padding(start = 20.dp, end = 20.dp, top = 8.dp, bottom = 12.dp)
        ) {
            Column {
                // NIVEL 1: MARCA Y FECHA
                Row(
                    verticalAlignment = Alignment.CenterVertically, 
                    modifier = Modifier.fillMaxWidth()
                ) {
                    IconButton(onClick = onMenuClick, modifier = Modifier.size(32.dp)) {
                        Icon(Icons.Default.Menu, null, tint = Color.White.copy(alpha = 0.9f))
                    }
                    Spacer(modifier = Modifier.width(4.dp))
                    Icon(
                        imageVector = Icons.Default.Balance, 
                        contentDescription = null, 
                        tint = Color(0xFFFFD700), 
                        modifier = Modifier.size(24.dp)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        text = "Jurídico Rosario",
                        style = MaterialTheme.typography.titleMedium.copy(
                            fontWeight = FontWeight.ExtraBold,
                            letterSpacing = 0.5.sp
                        ),
                        color = Color.White,
                        maxLines = 1
                    )
                    Spacer(modifier = Modifier.weight(1f))
                    Text(
                        text = currentDateString(),
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.White.copy(alpha = 0.7f)
                    )
                }

                Spacer(Modifier.height(12.dp))

                // NIVEL 2: SALUDO Y ESTADO
                Row(
                    verticalAlignment = Alignment.CenterVertically, 
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.weight(1f)
                    ) {
                        Text(
                            text = "Hola, Dr. $displayName", 
                            style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Bold), 
                            color = Color.White,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        Spacer(modifier = Modifier.width(6.dp))
                        Icon(
                            imageVector = Icons.Default.FrontHand,
                            contentDescription = null,
                            tint = Color(0xFFFFD700),
                            modifier = Modifier.size(14.dp).rotate(-20f)
                        )
                    }
                    
                    val accessState = AppUsageManager.instance.checkAccess()
                    val isPremiumActual = userStatus.isPremium
                    
                    StatusBadge(
                        accessState = accessState,
                        userStatus = userStatus
                    )

                    Spacer(modifier = Modifier.width(8.dp))
                    
                    val buttonText = when {
                        !isLoggedIn -> "Iniciar sesión"
                        !isPremiumActual -> "Hazte Premium"
                        else -> "Premium Activo"
                    }

                    Column(horizontalAlignment = Alignment.CenterHorizontally) {
                        Button(
                            onClick = onPaywallClick,
                            colors = ButtonDefaults.buttonColors(
                                containerColor = if (isDark) Color.Transparent else MaterialTheme.colorScheme.secondary, 
                                contentColor = if (isDark) MaterialTheme.colorScheme.secondary else Color.Black
                            ),
                            shape = CircleShape,
                            elevation = ButtonDefaults.buttonElevation(
                                defaultElevation = if (isDark) 0.dp else 2.dp,
                                pressedElevation = 0.dp
                            ),
                            border = if (isDark) BorderStroke(1.5.dp, MaterialTheme.colorScheme.secondary) else null,
                            contentPadding = PaddingValues(horizontal = 16.dp, vertical = 0.dp),
                            modifier = Modifier.height(36.dp)
                        ) {
                            if (isPremiumActual) {
                                Icon(
                                    imageVector = Icons.Default.WorkspacePremium,
                                    contentDescription = null,
                                    modifier = Modifier.size(16.dp),
                                    tint = if (isDark) MaterialTheme.colorScheme.secondary else Color.Black
                                )
                                Spacer(modifier = Modifier.width(6.dp))
                            }
                            Text(
                                text = buttonText, 
                                fontSize = 11.sp, 
                                fontWeight = FontWeight.ExtraBold,
                                letterSpacing = 0.5.sp
                            )
                        }
                        
                        if (!isPremiumActual) {
                            Spacer(modifier = Modifier.height(6.dp))
                            OutlinedButton(
                                onClick = onPromoClick,
                                modifier = Modifier.height(28.dp),
                                shape = CircleShape,
                                border = BorderStroke(
                                    width = 1.dp,
                                    color = MaterialTheme.colorScheme.secondary.copy(alpha = 0.5f)
                                ),
                                colors = ButtonDefaults.outlinedButtonColors(
                                    containerColor = MaterialTheme.colorScheme.secondary.copy(alpha = 0.12f),
                                    contentColor = MaterialTheme.colorScheme.secondary
                                ),
                                contentPadding = PaddingValues(horizontal = 10.dp, vertical = 0.dp)
                            ) {
                                Icon(
                                    imageVector = Icons.Default.CardGiftcard,
                                    contentDescription = null,
                                    modifier = Modifier.size(14.dp),
                                    tint = MaterialTheme.colorScheme.secondary
                                )
                                Spacer(modifier = Modifier.width(4.dp))
                                Text(
                                    text = "¿Código Institucional?",
                                    fontSize = 10.sp,
                                    fontWeight = FontWeight.Bold,
                                    letterSpacing = 0.3.sp
                                )
                            }
                        }
                    }
                }

                val focusManager = LocalFocusManager.current
                Spacer(Modifier.height(16.dp))
                SearchBarSimple(
                    query = searchQuery,
                    onQueryChange = onSearchQueryChange,
                    onFocusChange = { isSearchFocused = it },
                    focusRequester = focusRequester,
                    placeholder = searchHint,
                    onSearchAction = {
                        if (searchQuery.isNotBlank()) {
                            focusManager.clearFocus()
                            onConsultAIClick(searchQuery)
                        }
                    }
                )

                if (isSearchNoResults) {
                    val focusManager = LocalFocusManager.current
                    Surface(
                        onClick = {
                            focusManager.clearFocus()
                            scope.launch {
                                delay(150)
                                onConsultAIClick(searchQuery)
                            }
                        },
                        shape = RoundedCornerShape(topStart = 0.dp, topEnd = 0.dp, bottomStart = 24.dp, bottomEnd = 24.dp),
                        color = MaterialTheme.colorScheme.primaryContainer,
                        border = BorderStroke(1.dp, MaterialTheme.colorScheme.primary.copy(alpha = 0.3f)),
                        modifier = Modifier
                            .fillMaxWidth()
                            .offset(y = (-4).dp)
                            .shadow(elevation = 4.dp, shape = RoundedCornerShape(bottomStart = 24.dp, bottomEnd = 24.dp))
                    ) {
                        Row(
                            modifier = Modifier.padding(start = 16.dp, end = 16.dp, top = 16.dp, bottom = 14.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Icon(Icons.Default.AutoAwesome, contentDescription = null, tint = Color(0xFFFFD700))
                            Spacer(Modifier.width(12.dp))
                            Text(
                                text = "Preguntar a IA: \"$searchQuery\"",
                                color = MaterialTheme.colorScheme.onPrimaryContainer,
                                style = MaterialTheme.typography.bodyMedium,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier.weight(1f),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                            Spacer(Modifier.width(8.dp))
                            Icon(
                                imageVector = Icons.AutoMirrored.Filled.Send,
                                contentDescription = "Enviar a IA",
                                tint = MaterialTheme.colorScheme.primary,
                                modifier = Modifier.size(20.dp)
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun StatusBadge(
    accessState: AccessState, 
    userStatus: UserStatus
) {
    val verificationStatus by AppUsageManager.instance.verificationStatus.collectAsState()
    
    val labelAndColors = when {
        verificationStatus == VerificationStatus.GRACE_PERIOD -> Triple("VERIFICAR CUENTA", Color.White.copy(alpha = 0.15f), Color.White)
        else -> null
    } ?: return

    val (label, bgColor, textColor) = labelAndColors

    Surface(
        color = bgColor,
        shape = RoundedCornerShape(8.dp)
    ) {
        Text(
            text = label,
            modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp),
            style = MaterialTheme.typography.labelSmall.copy(
                fontWeight = FontWeight.ExtraBold,
                fontSize = 9.sp
            ),
            color = textColor
        )
    }
}

@Composable
fun CalendarioPlaceholder(navController: NavController, navigate: (String) -> Unit) {
    val isDark = isSystemInDarkTheme()
    Card(
        modifier  = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
        shape     = RoundedCornerShape(16.dp),
        colors    = CardDefaults.cardColors(
            containerColor = if (isDark) MaterialTheme.colorScheme.surfaceVariant else Color(0xFF1A4B8C)
        ),
        elevation = CardDefaults.cardElevation(defaultElevation = if (isDark) 0.dp else 6.dp)
    ) {
        Column(modifier = Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.CalendarToday, null, tint = Color(0xFFFFD700), modifier = Modifier.size(16.dp))
                Spacer(modifier = Modifier.width(8.dp))
                Text("Plazos Judiciales", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = Color.White)
            }
            Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                Button(onClick = { navigate(Routes.CALCULADORA_DIAS) }, modifier = Modifier.weight(1f), colors = ButtonDefaults.buttonColors(containerColor = Color.White, contentColor = Color(0xFF1A4B8C)), contentPadding = PaddingValues(0.dp)) {
                    Text("Contador de Días", fontSize = 12.sp)
                }
                Button(onClick = { navigate(Routes.CALCULADORA_VENCIMIENTOS) }, modifier = Modifier.weight(1f), colors = ButtonDefaults.buttonColors(containerColor = Color.White, contentColor = Color(0xFF1A4B8C)), contentPadding = PaddingValues(0.dp)) {
                    Text("Caducidad", fontSize = 12.sp)
                }
            }
        }
    }
}

@Composable
fun PagerIndicator(count: Int, selectedIndex: Int) {
    Row(modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp), horizontalArrangement = Arrangement.Center) {
        repeat(count) { index ->
            Box(
                modifier = Modifier
                    .padding(horizontal = 4.dp)
                    .size(if (index == selectedIndex) 8.dp else 6.dp)
                    .clip(CircleShape)
                    .background(if (index == selectedIndex) MaterialTheme.colorScheme.primary else Color.Gray)
            )
        }
    }
}

@Composable
fun SegmentedControl(secciones: Array<SeccionDashboard>, seleccionada: SeccionDashboard, onSeleccion: (SeccionDashboard) -> Unit) {
    val isDark = isSystemInDarkTheme()
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .height(52.dp)
            .shadow(if (isDark) 0.dp else 4.dp, RoundedCornerShape(26.dp)),
        color = if (isDark) MaterialTheme.colorScheme.surfaceVariant else Color(0xFFEDF2F7),
        shape = RoundedCornerShape(26.dp),
        border = BorderStroke(
            1.dp,
            if (isDark) MaterialTheme.colorScheme.onSurface.copy(alpha = 0.05f) else Color(0xFFE2E8F0)
        )
    ) {
        Row(
            modifier = Modifier.padding(4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            secciones.forEach { seccion ->
                val sel = seccion == seleccionada
                Box(
                    modifier = Modifier
                        .weight(1f)
                        .fillMaxHeight()
                        .clip(RoundedCornerShape(22.dp))
                        .background(
                            if (sel) MaterialTheme.colorScheme.primary 
                            else Color.Transparent
                        )
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = ripple(),
                            onClick = { onSeleccion(seccion) }
                        )
                        .then(
                            if (sel && !isDark) Modifier.shadow(2.dp, RoundedCornerShape(22.dp))
                            else Modifier
                        ),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = seccion.titulo,
                        fontWeight = if (sel) FontWeight.Bold else FontWeight.Medium,
                        color = if (sel) Color.White else MaterialTheme.colorScheme.onSurfaceVariant,
                        fontSize = 10.sp,
                        textAlign = TextAlign.Center,
                        lineHeight = 11.sp,
                        modifier = Modifier.padding(horizontal = 4.dp)
                    )
                }
            }
        }
    }
}

@Composable
fun ValoresReferenciaCard() {
    val isDark = isSystemInDarkTheme()
    Card(
        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
        shape = RoundedCornerShape(16.dp),
        colors = CardDefaults.cardColors(
            containerColor = if (isDark) {
                MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.2f)
            } else {
                Color(0xFFF8FAFC)
            }
        ),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
        border = if (isDark) {
            BorderStroke(1.dp, MaterialTheme.colorScheme.onSurface.copy(alpha = 0.05f))
        } else {
            BorderStroke(1.dp, Color(0xFFF1F5F9))
        }
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(vertical = 10.dp, horizontal = 8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            ValorItem("JUS", AppMontos.JUS_FORMATEADO, "Poder Jud.", Icons.Default.AccountBalance, Color(0xFFFFD700), Modifier.weight(1.25f))
            ValorItem("Carta", AppMontos.CARTA_DOCUMENTO_STR, "Correo Arg.", Icons.Default.Mail, Color(0xFF4A90E2), Modifier.weight(0.85f))
            ValorItem("Cédula", AppMontos.CEDULA_NOTIFICACION_STR, "Notif.", Icons.Default.Assignment, Color(0xFFE67E22), Modifier.weight(0.9f))
        }
    }
}

@Composable
fun ValorItem(label: String, valor: String, subLabel: String, icono: ImageVector, iconColor: Color, modifier: Modifier) {
    Column(modifier = modifier, horizontalAlignment = Alignment.CenterHorizontally) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            Icon(icono, null, modifier = Modifier.size(11.dp), tint = iconColor)
            Text(label, style = MaterialTheme.typography.labelSmall, modifier = Modifier.padding(start = 4.dp), fontSize = 9.sp, maxLines = 1)
        }
        Text(
            text = valor,
            style = MaterialTheme.typography.titleSmall,
            fontWeight = FontWeight.ExtraBold,
            fontSize = 13.sp,
            maxLines = 1,
            softWrap = false,
            overflow = TextOverflow.Visible
        )
        Text(subLabel, style = MaterialTheme.typography.labelSmall, fontSize = 8.sp, maxLines = 1)
    }
}

@Composable
fun DashboardGridItem(titulo: String, subtitulo: String, icono: ImageVector, onClick: () -> Unit) {
    val isDark = isSystemInDarkTheme()
    val interactionSource = remember { MutableInteractionSource() }
    val isPressed by interactionSource.collectIsPressedAsState()
    
    val scale by animateFloatAsState(
        targetValue = if (isPressed) 0.97f else 1f,
        animationSpec = spring(dampingRatio = Spring.DampingRatioLowBouncy, stiffness = Spring.StiffnessLow)
    )

    Card(
        onClick = onClick, 
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 2.dp)
            .graphicsLayer {
                scaleX = scale
                scaleY = scale
                clip = true
                shape = RoundedCornerShape(16.dp)
            }, 
        shape = RoundedCornerShape(16.dp), 
        colors = CardDefaults.cardColors(
            containerColor = if (isDark) MaterialTheme.colorScheme.surface else Color.White
        ), 
        elevation = CardDefaults.cardElevation(
            defaultElevation = if (isDark) 0.dp else 4.dp,
            pressedElevation = if (isDark) 0.dp else 2.dp
        ),
        border = if (isDark) {
            BorderStroke(1.dp, MaterialTheme.colorScheme.onSurface.copy(alpha = 0.05f))
        } else {
            BorderStroke(1.dp, Color(0xFFE2E8F0))
        },
        interactionSource = interactionSource
    ) {
        Column(modifier = Modifier.padding(20.dp)) {
            Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.Top) {
                Icon(
                    imageVector = icono, 
                    contentDescription = null, 
                    tint = MaterialTheme.colorScheme.primary, 
                    modifier = Modifier.size(28.dp)
                )
                Icon(
                    imageVector = Icons.Default.ChevronRight,
                    contentDescription = null,
                    tint = MaterialTheme.colorScheme.onSurfaceVariant.copy(alpha = 0.3f),
                    modifier = Modifier.size(16.dp)
                )
            }
            Spacer(Modifier.height(12.dp))
            Text(
                text = titulo, 
                fontWeight = FontWeight.SemiBold, 
                style = MaterialTheme.typography.titleSmall.copy(
                    lineHeight = 16.sp
                ), 
                color = MaterialTheme.colorScheme.onSurface, 
                maxLines = 2,
                overflow = TextOverflow.Ellipsis
            )
            Spacer(Modifier.height(4.dp))
            Text(
                text = subtitulo, 
                style = MaterialTheme.typography.bodySmall.copy(
                    fontSize = 11.sp,
                    lineHeight = 14.sp
                ), 
                color = MaterialTheme.colorScheme.onSurfaceVariant, 
                maxLines = 2, 
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
fun MenuItemDashboard(titulo: String, subtitulo: String, icono: ImageVector, onClick: () -> Unit, badge: String? = null) {
    val isDark = isSystemInDarkTheme()
    Card(
        onClick = onClick, 
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp)
            .graphicsLayer {
                // Optimización para scroll fluido en Web
                clip = true
                shape = RoundedCornerShape(12.dp)
            }, 
        shape = RoundedCornerShape(12.dp), 
        colors = CardDefaults.cardColors(
            containerColor = if (isDark) MaterialTheme.colorScheme.surface else Color.White
        ), 
        elevation = CardDefaults.cardElevation(defaultElevation = if (isDark) 0.dp else 2.dp),
        border = if (isDark) {
            BorderStroke(1.dp, MaterialTheme.colorScheme.onSurface.copy(alpha = 0.05f))
        } else {
            BorderStroke(1.dp, Color(0xFFE2E8F0))
        }
    ) {
        Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(icono, null, tint = MaterialTheme.colorScheme.primary, modifier = Modifier.size(20.dp))
            Spacer(Modifier.width(12.dp))
            Column(modifier = Modifier.weight(1f)) {
                Text(titulo, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodySmall)
                Text(subtitulo, style = MaterialTheme.typography.labelSmall, fontSize = 10.sp)
            }
            if (badge != null) {
                Surface(color = MaterialTheme.colorScheme.primary, shape = CircleShape) {
                    Text(badge, color = Color.White, modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp), style = MaterialTheme.typography.labelSmall, fontSize = 9.sp)
                }
            }
        }
    }
}

@Composable
fun PromoCodeDialog(
    onDismissRequest: () -> Unit,
    onSuccess: (String) -> Unit
) {
    var code by remember { mutableStateOf("") }
    var canjeExitoso by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    var errorMessage by remember { mutableStateOf<String?>(null) }

    val scope = rememberCoroutineScope()
    val focusManager = LocalFocusManager.current

    val handleCanjear = {
        if (code.isBlank()) {
            errorMessage = "Ingresa un código"
        } else if (!isLoading && !canjeExitoso) {
            errorMessage = null
            isLoading = true

            scope.launch {
                val result = FirebaseProxy.canjearPromo(code)
                when (result) {
                    is PromoResult.Success -> {
                        isLoading = false
                        canjeExitoso = true
                        delay(600)
                        focusManager.clearFocus()
                        onDismissRequest()
                        delay(150)
                        onSuccess(code)
                    }
                    is PromoResult.Error -> {
                        errorMessage = result.message
                        isLoading = false
                    }
                }
            }
        }
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.5f))
            .zIndex(100f)
            .pointerInput(Unit) { detectTapGestures {} },
        contentAlignment = Alignment.Center
    ) {
        Surface(
            modifier = Modifier
                .fillMaxWidth(0.9f)
                .widthIn(max = 440.dp)
                .padding(16.dp),
            shape = RoundedCornerShape(24.dp),
            color = MaterialTheme.colorScheme.surface,
            tonalElevation = 6.dp,
            shadowElevation = 8.dp
        ) {
            Column(
                modifier = Modifier.padding(24.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(16.dp)
            ) {
                Text(
                    text = if (canjeExitoso) "¡Beneficio Activado!" else "Código Institucional",
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = MaterialTheme.colorScheme.onSurface
                )

                Text(
                    text = if (canjeExitoso) "El beneficio de cortesía fue activado con éxito en tu cuenta."
                           else "Ingresa tu código de convenio para habilitar funciones Premium sin cargo.",
                    style = MaterialTheme.typography.bodyMedium,
                    textAlign = TextAlign.Center,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )

                OutlinedTextField(
                    value = code,
                    onValueChange = {
                        if (!isLoading && !canjeExitoso) {
                            code = it.uppercase().trim()
                            errorMessage = null
                        }
                    },
                    label = { Text("Ingresar Código") },
                    modifier = Modifier.fillMaxWidth(),
                    singleLine = true,
                    isError = errorMessage != null,
                    shape = RoundedCornerShape(12.dp),
                    supportingText = {
                        if (canjeExitoso) {
                            Text("✓ Código validado correctamente", color = Color(0xFF2E7D32))
                        } else if (errorMessage != null) {
                            Text(errorMessage!!)
                        }
                    },
                    enabled = !isLoading && !canjeExitoso,
                    keyboardOptions = KeyboardOptions(imeAction = ImeAction.Done),
                    keyboardActions = KeyboardActions(onDone = { if (!isLoading && !canjeExitoso) handleCanjear() })
                )

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.End,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    TextButton(
                        onClick = { if (!isLoading && !canjeExitoso) onDismissRequest() },
                        enabled = !isLoading && !canjeExitoso
                    ) {
                        Text("Más tarde")
                    }
                    Spacer(modifier = Modifier.width(8.dp))
                    Button(
                        onClick = { handleCanjear() },
                        shape = RoundedCornerShape(8.dp),
                        enabled = code.isNotBlank() && !isLoading && !canjeExitoso
                    ) {
                        Text(
                            when {
                                canjeExitoso -> "¡Activado!"
                                isLoading -> "Validando..."
                                else -> "Canjear Ahora"
                            }
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun SeccionTituloDashboard(titulo: String) {
    Row(modifier = Modifier.padding(start = 16.dp, top = 24.dp, bottom = 8.dp), verticalAlignment = Alignment.CenterVertically) {
        Box(modifier = Modifier.width(4.dp).height(18.dp).background(Color(0xFFFFD700)))
        Text(
            text = titulo, 
            modifier = Modifier.padding(start = 10.dp), 
            fontWeight = FontWeight.ExtraBold, 
            style = MaterialTheme.typography.titleMedium
        )
    }
}
